const SecondDayDeliverys = () => {
    return (
      <div>
     
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                2nd Day Delivery
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              A reliable service at economical rates, TCS Economy Express is an overland service. As a standard 
              second day delivery option, over 80% of Economy Express shipments are delivered within half the committed time. 
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/DomesticScrollingBanner/image3.jpg" alt="" className="w-[100%] rounded-md sm:mt-[0rem] mt-[1rem]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default SecondDayDeliverys;